import { defineStore } from "pinia";
import { ref } from "vue";

import { type Nullable } from "shared/types/utility";

export interface ActionCableSubscriptionData {
  action: string;
  completed: boolean;
  error: string;
  processed: number;
  total: number;
  user: { name: string; id: number };
  timestamp: number;
}

export const useInsightsStore = defineStore("insights", () => {
  const querySubscriptionData = ref<Nullable<ActionCableSubscriptionData>>(
    querySubscriptionDataDefault
  );

  return {
    querySubscriptionData,
  };
});

const querySubscriptionDataDefault: ActionCableSubscriptionData = {
  action: "",
  completed: true,
  error: "",
  processed: 0,
  total: 0,
  user: { name: "", id: 0 },
  timestamp: 0,
};
